export const themes = {
  light: {
    sidebar: {
      backgroundColor: '#343a40',
      color: '#607489',
    },
    menu: {
      menuContent: '#000a17',
      icon: '#0098e5',
      hover: {
        backgroundColor: '#4e565e',
        color: '#fff',
      },
      disabled: {
        color: '#5b81aa',
      },
    },
  },
  dark: {
    sidebar: {
      backgroundColor: '#343a40',
      color: '#8ba1b7',
    },
    menu: {
      menuContent: '#000a17',
      icon: '#59d0ff',
      hover: {
        backgroundColor: '#343a40',
        color: '#ff9935',
      },
      disabled: {
        color: '#5b81aa',
      },
    },
  },
};
